import React from 'react'

export default function TitleCard(props) {
  return (
    <p className='m-0 p-0 ps-2' style={{fontWeight: '600', letterSpacing: '1.4px',}}>{props.children}</p>
  )
}
